const MentorNextSessionPlaceholder = () => (
    <>
   
    <div className="mb-3" aria-label="Next session">
        <div className="small fw-bold text-secondary text-uppercase tracking-wider font-11 mb-2">Next Session</div>
        <div className="card border-0 shadow-sm rounded-3 p-3 bg-white">
        <div className="d-flex flex-wrap align-items-center gap-3">
            <div className="bg-primary bg-opacity-10 p-2 rounded-3 text-center d-flex flex-column align-items-center justify-content-center flex-shrink-0" style={{width:'60px',height:'60px'}}>
            <div className="fw-bold text-primary fs-4 lh-1">-</div>
            <div className="text-uppercase text-primary font-10 fw-bold mt-1">-</div>
            </div>
            <div className="flex-grow-1">
            <h6 className="font-600 mb-1 text-dark">No session scheduled</h6>
            <p className="text-secondary small mb-2"><i className="bi bi-calendar-event me-1"></i> Scheduling arrives with Sessions</p>
            <div className="d-flex flex-wrap gap-1">
                <span className="badge bg-primary bg-opacity-10 text-primary border border-primary border-opacity-25 font-11">__</span>
                <span className="badge bg-primary bg-opacity-10 text-primary border border-primary border-opacity-25 font-11">__</span>
            </div>
            </div>
            <div className="d-flex gap-2">
            <button className="btn btn-sm btn-outline-secondary font-500 rounded-pill px-3" >📋 View Agenda</button>
            <button className="btn btn-sm btn-success text-white font-500 rounded-pill px-3" >▶ Join Session</button>
            </div>
        </div>
        </div>
    </div>
    </>
);

export default MentorNextSessionPlaceholder;
